import React, { useState } from "react";
import { Form, FormFeedback, Input } from "reactstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { addCommentByPodcast } from "@store/action/planning/PodcastAction";
import GoogleAuth from "@src/auth/socialAuth";

const detailblogForm = ({ t }) => {
  const { id } = useParams();
  const { handleSubmit } = useForm();
  const [body, setComment] = useState("");
  const CommentReducer = useSelector((state) => state.podcastReducer);
  const authReducer = useSelector((state) => state.auth.social_user);
  const dispatch = useDispatch();
  const emptyField = () => {
    setComment("");
  };
  const handleAddComment = () => {
    const datas = {
      name: `${authReducer.first_name} ${authReducer.last_name}`,
      email: authReducer.email,
      body,
      avatar: authReducer.avatar,
    };
    dispatch(
      addCommentByPodcast(datas, id, emptyField, {
        page: 1,
        per_page: 5,
      })
    );
  };

  return (
    <div className="blog-det-Form">
      <h3>{t("Leave Your Comment")}</h3>
      {authReducer !== null ? (
        <Form
          style={{ marginTop: "15px", borderTop: "1px solid", padding: "10px" }}
          onSubmit={handleSubmit(handleAddComment)}
        >
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <img
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  src={authReducer?.avatar}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <Input
                  type="text"
                  placeholder={t("Your Name")}
                  id="name"
                  value={`${authReducer.first_name} ${authReducer.last_name}`}
                  disabled
                  invalid={
                    CommentReducer.error && CommentReducer.error.name && true
                  }
                />
                <FormFeedback>
                  {CommentReducer.error &&
                    CommentReducer.error.name &&
                    CommentReducer.error.name}
                </FormFeedback>
                <i className="fa fa-user"></i>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <Input
                  type="email"
                  placeholder={t("Your Email")}
                  id="email"
                  value={authReducer.email}
                  disabled
                  invalid={
                    CommentReducer.error && CommentReducer.error.email && true
                  }
                />
                <FormFeedback>
                  {CommentReducer.error &&
                    CommentReducer.error.email &&
                    CommentReducer.error.email}
                </FormFeedback>
                <i className="fa fa-envelope"></i>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group">
                <textarea
                  placeholder={t("Your Comment")}
                  id="body"
                  onChange={(e) => setComment(e.target.value)}
                  value={body}
                />
                {CommentReducer.error && CommentReducer.error.body && (
                  <p
                    style={{
                      width: "100%",
                      fontSize: "0.857rem",
                      color: "#ea5455",
                    }}
                  >
                    {CommentReducer.error.body}
                  </p>
                )}
                <i className="fa fa-pencil"></i>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-btn">
                <button type="submit" className="btn btn-inline">
                  <i className="fa fa-tint me-1"></i>
                  <span>{t("Drop your comment")}</span>
                </button>
              </div>
            </div>
          </div>
        </Form>
      ) : (
        <GoogleAuth />
      )}
    </div>
  );
};

export default detailblogForm;
